module.exports = __webpack_public_path__ + "img/Proliferation-OVCA_10X_WTA.41d6a3ff.png";